module.exports = __webpack_public_path__ + "static/media/Fright Knight.ec62c3a2.jpg";